import React from 'react'
import { ArrowLeft } from 'lucide-react'
import Share from './micro-components/Share'

const Header: React.FC = () => {
  return (
    <div className='flex flex-row justify-between py-4 px-0 sm:px-0 sm:py-4'>
      <div className='flex flex-row gap-3.5'>
        <span className="text-[#000] font-ubuntu text-[20px] font-medium leading-[32px] tracking-[-0.2px]">
          Report
        </span>
      </div>
      
      <Share title="Share this report" />
    </div>
  )
}

export default Header